import rnHttp from 'rhino/src/core/http/http.module';
import rnOrganization from 'rhino/src/components/organization/organization.module';

import * as gzUserImageController from './user-image.controller';
import * as gzOrgImageController from './org-image.controller';
import * as gzProfileImageService from './profile-image.service';
import * as croppieDirective from './croppie.directive.js';
import './profile-image.scss';
import './croppie.scss';

import ngMaterial from 'angular-material';
import angularTranslate from 'angular-translate';
import Upload from 'ng-file-upload';
import rnCore from 'rhino/src/core/core.module';
import gazelleAnalytics from 'gazelle/src/core/analytics/analytics.module';

export default angular.module('gazelle.components.profileImage', [
  ngMaterial,
  rnHttp,
  rnOrganization,
  Upload,
  angularTranslate,
  'ui.router',
  rnCore,
  gazelleAnalytics
])
  .controller(gzUserImageController.name, gzUserImageController.default)
  .controller(gzOrgImageController.name, gzOrgImageController.default)
  .service(gzProfileImageService.name, gzProfileImageService.default)
  .directive(croppieDirective.name, croppieDirective.default)
  .name;
